import { useEffect, useState } from "react";
import styled from "styled-components";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";
import {
  getReferenceInfo,
  getWinOddsInfo,
} from "@/app/utils/request/requestList";
import { useMyContext } from "@/app/utils/MyContext";
import { LANGTYPE_CT, LANGTYPE_EN, LangType, useLanguage } from "@/app/utils/LanguageContext";
import { formattedDate, dateFormat, toDate } from "@/app/utils/DayJS";
import { GET_WINODDS_INFO } from "@/app/utils/request/query";
import { textSize, text_size } from "@/app/utils/MixinSize";
import _ from "lodash";
import styles from "@/app/ui/HomePage/index.module.css";
import { useClickReflesh, getSearchParams, setRacesDetailLoading, defaultValue } from "@/app/utils/Common";
import NoInformation from "@/app/ui/Common/NoInformation";
import { oddType } from "@/app/utils/constant/odd";

const ReferenceOddsTitle = styled.div`
  width: 100%;
  height: 50px;
  padding: 0 12px;
  ${text_size(15)}
  line-height: 50px;
  font-weight: 500;
  background-color: #ededed;
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 10%);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LastUpdate = styled.div`
  width: 100%;
  ${text_size(11)}
  font-weight: 500;
  margin: 8px 0px;
`;
const ReferenceOddsRed = styled.div`
  display: block;
  width: 27px;
  height: 24px;
  line-height: 24px;
  margin: 0 auto;
  border-radius: 4px;
  background-color: #f03939;
  color: white;
  text-align: center;
`;
const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.root}`]: {
    color: "#333333",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#E1E1E1",
    fontWeight: 400,
    padding: "8px 0px 8px 8px",
    ...textSize(11),
    textAlign: "center",
    height: "32px",
    lineHeight: "16px",
    borderBottom: "0px",
  },
  [`&.${tableCellClasses.head}:last-child`]: {
    paddingRight: "8px",
  },
  [`&.${tableCellClasses.body}`]: {
    ...textSize(13),
    fontWeight: 500,
    padding: "4px 0px 4px 8px",
    verticalAlign: "baseline",
    textAlign: "center",
    height: "32px",
    lineHeight: "24px",
  },
}));

const StyledTableCellMobile = styled(TableCell)(() => ({
  [`&.${tableCellClasses.root}`]: {
    color: "#333333",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#E1E1E1",
    fontWeight: 400,
    ...textSize(11),
    padding: "6px 0px 6px 8px",
    textAlign: "center",
    lineHeight: "14px",
  },
  [`&.${tableCellClasses.head}:last-child`]: {
    paddingRight: "8px",
  },
  [`&.${tableCellClasses.body}`]: {
    ...textSize(13),
    fontWeight: 500,
    verticalAlign: "baseline",
    padding: "8px 0px 8px 8px",
    textAlign: "center",
    lineHeight: "17px",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#F4F4F4",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: "#FFFFFF",
  },
  "td, th": {
    border: 0,
  },
  "td:last-child, th:last-child": {
    paddingRight: "8px",
  },
}));
const HorseNameWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
const HorseNameText = styled.p`
  width: 100px;
`;
const ReferenceOdds: React.FC<any> = (props: any) => {
  const { type, meettings } = props;
  const [oddsData, setOddsData] = React.useState([]);
  const [leftData, setLeftData] = React.useState([]);
  const [rightData, setRightData] = React.useState([]);
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const { b_cid } = getSearchParams(new URLSearchParams(window.location.search));
  const { state: lang, dispatch: langDispatch } = useLanguage();
  const { t } = lang;
  const [referenceUpdate, setReferenceUpdate] = useState<any>("");
  const [winOddsUpdate, setWinOddsUpdate] = useState<any>("");
  const [WinOddsData, setWinOddsData] = useState<any>([]);
  const [leftWinOddsData, setLeftWinOddsData] = useState<any>([]);
  const [rightWinOddsData, setRightWinOddsData] = useState<any>([]);
  const [oddsLabels, setOddsLabels] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const { delay60sRefresh } = useClickReflesh();

  const getLeftRightData = (data: any) => {
    const len = data?.length;
    let firstHalf = [];
    let secondHalf = [];
    if (len) {
      if (len % 2 === 0) {
        const midPoint = len / 2;
        firstHalf = data.slice(0, midPoint);
        secondHalf = data.slice(midPoint);
      } else if (len !== 1) {
        const midPoint1 = (len + 1) / 2;
        firstHalf = data.slice(0, midPoint1);
        secondHalf = data.slice(midPoint1);
      } else {
        firstHalf = data;
      }
    }
    return [firstHalf, secondHalf];
  };
  const parseCSV = (csv: any, lang: LangType) => {
    if (!csv) return;
    const lines = csv?.split(/\r\n|\n/);
    const jsonArray: any = [];
    setOddsLabels(lines?.[0]?.split("\t")?.filter((l: any) => l));
    lines.forEach((line: any, index: any) => {
      if (index > 0) {
        const fields = line.split("\t");
        const saddleClothNo = fields[0];
        const horseName = fields[1];
        const otherName = lang === LANGTYPE_CT ? fields[2] : "";
        const referenceOdds = lang === LANGTYPE_CT ? fields[3] : fields[2];
        if (saddleClothNo) {
          const newNo = saddleClothNo.match(/\d+/)?.[0];
          jsonArray.push({
            no: newNo,
            SaddleClothNo: saddleClothNo,
            HorseName: horseName,
            OtherName: otherName,
            ReferenceOdds: referenceOdds,
          });
        }
      }
    });
    return jsonArray;
  };
  useEffect(() => {
    console.log("meettings", props.meettings);
    if (myContextState.isLoadingRaces) return;
    if (!myContextState.selectedMeeting?.displayName) {
      setReferenceUpdate("");
      setOddsData([]);
      getLeftRightData([]);
      setWinOddsUpdate("");
      setLeftWinOddsData([]);
      setRightWinOddsData([]);
      setRacesDetailLoading(props.setRacesDetailLoading)
      return;
    }

    getReferenceOddsData();
  }, [myContextState.selectedRace, myContextState.isLoadingRaces]);

  const getReferenceOddsData = () => {
    let refOddsData: any = [];
    setLoading(true);
      getReferenceInfo(
        lang.langCode,
        myContextState.season,
        myContextState.selectedMeeting?.displayName,
        myContextState.selectedRace?.displayName
      )
        .then((res) => {
          console.log("ReferenceOdds", res?.item);
          const time = formattedDate(
            toDate(res?.item?.ReferenceOddsTimestamp.value, dateFormat.cms.datetime),
            dateFormat.display.datetime
          );
          setReferenceUpdate(time);
          const resData = parseCSV(
            res?.item?.referenceOdds.value,
            lang.langType
          );
          setOddsData(resData);
          const rOddsData = getLeftRightData(resData);
          refOddsData = resData;
          setLeftData(rOddsData[0]);
          setRightData(rOddsData[1]);

          getWinOddsInfo(
            {
              date: formattedDate(myContextState.selectedMeetingDate, "YYYY-MM-DD"),
              venueCode: myContextState.selectedMeeting?.meetingVenueCode,
              oddsTypes: oddType.WIN,
            },
            GET_WINODDS_INFO,
            "qids"
          )
            .then((res) => {
              const resData = res.raceMeetingProfile?.[0];
              const raceNo = myContextState.selectedRaceNo.valueOf() ?? 0;
              const raceNoPool = resData?.pmPools?.find((pool: any) => pool.id.split("WIN")[1] == raceNo);
              const runners = resData?.races?.find((ra: any) => ra.no == raceNo)?.runners;
              if (raceNoPool) {
                console.log(
                  "getWinOddsInfo ->", resData?.pmPools,
                  raceNoPool?.lastUpdateTime
                );
                setWinOddsUpdate(
                  formattedDate(
                    toDate(raceNoPool?.lastUpdateTime, dateFormat.qids.datetimeWithMs),
                    dateFormat.display.datetime
                  )
                );
                const sortData = _.orderBy(
                  raceNoPool?.oddsNodes?.map((item: any, i: number) => {
                    return {
                      ...item,
                      combString: Number(item.combString)
                    };
                  }),
                  ["combString"],
                  ["asc"]
                );
                const filterData = refOddsData?.map(
                  (item: any) => {
                    return {
                      ...sortData[Number(item.no) - 1], 
                      runStus: runners?.find((run: any) => run.no == Number(item.no))?.status
                    }
                  }
                ); 
                
                const wOddsData = getLeftRightData(filterData);
                console.log("filterData", filterData)
                setWinOddsData(filterData);
                setLeftWinOddsData(wOddsData[0]);
                setRightWinOddsData(wOddsData[1]); 
              } else {
                setWinOddsUpdate("")
                setLeftWinOddsData([]);
                setRightWinOddsData([]);
              }
            })
            .catch((e) => {
              console.log(e);
            }).finally(() => {
              setLoading(false);
              setRacesDetailLoading(props.setRacesDetailLoading)
            });
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
          setRacesDetailLoading(props.setRacesDetailLoading)
        });
  };

  const onClickRefresh = () => {
    delay60sRefresh(loading, setLoading, () => getReferenceOddsData());
  };
  const renderRefleshIcon = (mobileCss = {}) => (
    <p onClick={onClickRefresh} style={{ display: "flex", ...mobileCss }}>
      <img
        id="reference_odds_refresh_Btn"
        className={`${(loading && styles["animateRefresh"]) || ""}`}
        style={{ filter: "invert(1) sepia(1) saturate(5) hue-rotate(175deg)" }}
        src={`${myContextState.assetPrefix}/Refresh_24px.svg`}
      />
    </p>
  );

  return (
    <>
      {type === "pc" ? (
        !leftData?.length && !rightData?.length ? (
          <NoInformation />
        ) : (
          <div>
            <ReferenceOddsTitle id="ReferenceOdds_Title">
              <p>{t("referenceOdds_title")}</p>
              {renderRefleshIcon()}
            </ReferenceOddsTitle>
            <TableContainer
              sx={{
                alignItems: "baseline",
                display: "flex",
                borderRadius: "0px 0px 4px 4px",
                boxShadow: "0px 2px 10px 0px rgb(0 0 0 / 10%)",
              }}
            >
              <Table
                id="ReferenceOdds_Table_1"
                sx={{ width: "50%", borderRight: "1px solid #B4B4B4" }}
                aria-label="simple table"
              >
                <TableHead id="ReferenceOdds_TableHead_1">
                  <TableRow>
                    <StyledTableCell>{oddsLabels?.[0]}</StyledTableCell>
                    <StyledTableCell sx={{ textAlign: "left !important" }}>
                      {oddsLabels?.[1]}
                    </StyledTableCell>
                    <StyledTableCell>{oddsLabels?.[2]}</StyledTableCell>
                    <StyledTableCell>{oddsLabels?.[3]}</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {leftData.map((row: any, index: any) => (
                    <StyledTableRow
                      key={row.SaddleClothNo}
                      id={`ReferenceOdds_left_${index}`}
                    >
                      <StyledTableCell>{row.SaddleClothNo}</StyledTableCell>
                      {lang.langType === LANGTYPE_CT ? (
                        <StyledTableCell sx={{ textAlign: "left !important" }}>
                          <HorseNameWrapper>
                            <p> {row.HorseName}</p>
                            <HorseNameText>{row.OtherName}</HorseNameText>
                          </HorseNameWrapper>
                        </StyledTableCell>
                      ) : (
                        <StyledTableCell sx={{ textAlign: "left !important" }}>
                          {row.HorseName}
                        </StyledTableCell>
                      )}

                      <StyledTableCell>{row.ReferenceOdds}</StyledTableCell>
                      <StyledTableCell>
                        {leftWinOddsData?.[index]?.hotFavourite &&
                        leftWinOddsData?.[index]?.oddsValue !== "---" ? (
                          <ReferenceOddsRed>
                            {leftWinOddsData?.[index]?.oddsValue}
                          </ReferenceOddsRed>
                        ) : leftWinOddsData?.[index]?.oddsValue === "SCR" || ["Scratched", "ScratchedReserved"].includes(leftWinOddsData?.[index]?.runStus) ? (
                          t("referenceOdds_scr")
                        ) : leftWinOddsData?.[index]?.oddsValue ? (
                          leftWinOddsData?.[index]?.oddsValue
                        ) : (
                          "---"
                        )}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              <Table
                id="ReferenceOdds_Table_2"
                sx={{ width: "50%" }}
                aria-label="simple table"
              >
                <TableHead id="ReferenceOdds_TableHead_2">
                  <TableRow>
                    <StyledTableCell>{oddsLabels?.[0]}</StyledTableCell>
                    <StyledTableCell sx={{ textAlign: "left !important" }}>
                      {oddsLabels?.[1]}
                    </StyledTableCell>
                    <StyledTableCell>{oddsLabels?.[2]}</StyledTableCell>
                    <StyledTableCell>{oddsLabels?.[3]}</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rightData.map((row: any, index: any) => (
                    <StyledTableRow
                      key={row.SaddleClothNo}
                      id={`ReferenceOdds_right_${index}`}
                    >
                      <StyledTableCell>{row.SaddleClothNo}</StyledTableCell>
                      {lang.langType === LANGTYPE_CT ? (
                        <StyledTableCell sx={{ textAlign: "left !important" }}>
                          <HorseNameWrapper>
                            <p> {row.HorseName}</p>
                            <HorseNameText>{row.OtherName}</HorseNameText>
                          </HorseNameWrapper>
                        </StyledTableCell>
                      ) : (
                        <StyledTableCell sx={{ textAlign: "left !important" }}>
                          {row.HorseName}
                        </StyledTableCell>
                      )}
                      <StyledTableCell>{row.ReferenceOdds}</StyledTableCell>
                      <StyledTableCell>
                        {rightWinOddsData?.[index]?.hotFavourite &&
                        rightWinOddsData?.[index]?.oddsValue !== "---" ? (
                          <ReferenceOddsRed>
                            {rightWinOddsData?.[index]?.oddsValue}
                          </ReferenceOddsRed>
                        ) : rightWinOddsData?.[index]?.oddsValue === "SCR" || ["Scratched", "ScratchedReserved"].includes(rightWinOddsData?.[index]?.runStus) ? ( 
                          t("referenceOdds_scr")
                        ) : rightWinOddsData?.[index]?.oddsValue ? (
                          rightWinOddsData?.[index]?.oddsValue
                        ) : (
                          "---"
                        )}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <LastUpdate>
              <span id="ReferenceOdds_LastUpdate">
                {t("referenceOdds_last_update")} {defaultValue(referenceUpdate, "-")}
              </span>
              <br />
              <span id="ReferenceOdds_HKJCWinOdds_LastUpdate">
                {t("hkjc_win_odds_last_update")} {defaultValue(winOddsUpdate, "-")}
              </span>
            </LastUpdate>
          </div>
        )
      ) : !oddsData?.length ? (
        <NoInformation />
      ) : (
        <div>
          {renderRefleshIcon({
            justifyContent: "flex-end",
            padding: 8,
          })}
          <TableContainer
            sx={{
              borderRadius: "0 0 1.06vw 1.06vw",
              boxShadow: "0px 2px 10px 0px rgb(0 0 0 / 10%)",
            }}
          >
            <Table id="ReferenceOdds_Table_1" aria-label="simple table">
              <TableHead id="ReferenceOdds_TableHead_1">
                <TableRow>
                  <StyledTableCellMobile sx={{ minWidth: 55 }}>
                    {oddsLabels?.[0]}
                  </StyledTableCellMobile>
                  <StyledTableCellMobile
                    sx={{ textAlign: "left !important", minWidth: 140 }}
                  >
                    {oddsLabels?.[1]}
                  </StyledTableCellMobile>
                  <StyledTableCellMobile>
                    {oddsLabels?.[2]}
                  </StyledTableCellMobile>
                  <StyledTableCellMobile sx={{ minWidth: 65 }}>
                    {oddsLabels?.[3]}
                  </StyledTableCellMobile>
                </TableRow>
              </TableHead>
              <TableBody>
                {oddsData?.map((row: any, index: any) => (
                  <StyledTableRow
                    key={row.SaddleClothNo}
                    id={`ReferenceOdds_mobile_${index}`}
                  >
                    <StyledTableCellMobile>
                      {row.SaddleClothNo}
                    </StyledTableCellMobile>
                    <StyledTableCellMobile
                      sx={{ textAlign: "left !important" }}
                    >
                      {lang.langType === LANGTYPE_CT ? (
                        <>
                          <p> {row.HorseName}</p>
                          <p>{row.OtherName}</p>
                        </>
                      ) : (
                        <p> {row.HorseName}</p>
                      )}
                    </StyledTableCellMobile>
                    <StyledTableCellMobile>
                      {row.ReferenceOdds}
                    </StyledTableCellMobile>
                    <StyledTableCellMobile>
                      {WinOddsData?.[index]?.hotFavourite &&
                      WinOddsData?.[index]?.oddsValue !== "---" ? (
                        <ReferenceOddsRed>
                          {WinOddsData?.[index]?.oddsValue}
                        </ReferenceOddsRed>
                      ) : WinOddsData?.[index]?.oddsValue === "SCR" || ["Scratched", "ScratchedReserved"].includes(WinOddsData?.[index]?.runStus) ? (
                          t("referenceOdds_scr") 
                      ) : WinOddsData?.[index]?.oddsValue ? (
                        WinOddsData?.[index]?.oddsValue
                      ) : (
                        "---"
                      )}
                    </StyledTableCellMobile>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <LastUpdate>
            <span id="ReferenceOdds_LastUpdate">
              {t("referenceOdds_last_update")} {defaultValue(referenceUpdate, "-")}
            </span>
            <br />
            <span id="ReferenceOdds_HKJCWinOdds_LastUpdate">
              {t("hkjc_win_odds_last_update")} {defaultValue(winOddsUpdate, "-")}
            </span>
          </LastUpdate>
        </div>
      )}
    </>
  );
};
export default ReferenceOdds;
